import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <Link
            className="site-wordmark"
            to="/"
            aria-label={`${siteConfig.brandName} home`}
          >
            <img src={siteConfig.logo} alt={siteConfig.wordmark} />
          </Link>
          <p>{siteConfig.description}</p>

          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <address>
            {siteConfig.contact.company}
            <br />
            {siteConfig.contact.address}
          </address>
        </div>

        <div className="footer-column">
          <h3>Help</h3>
          <Link to="/contact">Contact us</Link>
          <Link to="/shipping">Shipping</Link>
          <Link to="/returns">Returns</Link>
          <Link to="/contact">Track my order</Link>
        </div>

        <div className="footer-column">
          <h3>About</h3>
          <Link to="/about">Our story</Link>
          <Link to="/about#craft">Savoir-faire</Link>
          <Link to="/shop">The collection</Link>
          <Link to="/contact">Our locations</Link>
        </div>

        <div className="footer-column">
          <h3>Legal</h3>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms & conditions</Link>
          <Link to="/returns">Return policy</Link>
          <Link to="/cookies">Cookie policy</Link>
          <Link to="/faqs">FAQs</Link>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <span>Hong Kong / USD</span>
        <span>Designed for a slower wardrobe</span>
      </div>
    </footer>
  );
}

export default Footer;
